import React, { useContext, useEffect, useState } from "react";
import "../components/style_v2.css"
import "../components/style.css";
import 'lightbox2/dist/css/lightbox.min.css';
import 'lightbox2/dist/js/lightbox.min.js';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.min.js";
import Navbar from '../components/Navbar';
import Carousel from '../components/Carousel';
import Topbar from '../components/Topbar';
import Gallery from '../components/home/home_Gallery';
import AiStrategySection from "../components/product_ai/AiStrategySection";
import AiProjectsSection from "../components/product_ai/AiProjectsSection";
import SecurityFeatures from '../components/home/home_SecurityFeatures';
import AiProjectsSection2 from "../components/product_ai/AiProjectsSection2";
import AiProjectsSectionVideo from "../components/product_ai/AiProjectsSectionVideo";
import { LanguageContext } from "../context/LanguageContext";
import StrategyDemoModal from "../components/product_ai/StrategyDemoModal";

const Page = () => {
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);
  const [showDemoModal, setShowDemoModal] = useState(true);

  useEffect(() => {
    loadLanguageFile("AiStrategySection", "product/product_ai_lang");
  }, [language]);

  const handleCloseModal = () => {
    setShowDemoModal(false);
  };

  const LANGUAGE = componentLanguageData.AiStrategySection || { Main: {} };
  return (
    <div>
      <title>{LANGUAGE.Main.Title}</title>
      <StrategyDemoModal open={showDemoModal} onClose={handleCloseModal} />
      <Topbar />
      <Navbar />
      <Carousel />
      <Gallery />
      <AiProjectsSectionVideo />
      <AiProjectsSection />
      <AiProjectsSection2 />
      <AiStrategySection />
      <SecurityFeatures />
    </div>
  );
};

export default Page;